import { createContext } from "react";
import { DownloadManager } from "./DownloadManager";

export const DownloadManagerContext = createContext<DownloadManager | null>(
  null
);
